import template from './radniNalogDetails.html';
import swal from 'sweetalert';
import lightbox from 'lightbox2';
import { OTVOREN, ZAKLJUCAN, UOBRADI, STORNIRAN } from './statusi.js';

class RadniNalogDetailsController {
    constructor(DS, AppConfiguration, $uibModal, $q, $timeout, Upload, $cookies, logger, $http) {
        this.icon = false;
        this.$uibModal = $uibModal;
        this.$q = $q;
        this.$timeout = $timeout;
        this.logger = logger;
        this.pageTitle = 'Radni nalog:' || false;
        this.pageDesc = 'Podaci o radnom nalogu';
        this.datastore = () => {
            return DS;
        };
        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
        this.stavkeListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
        this.upload = () => Upload;
        this.$cookies = () => $cookies;
        this.$http = () => $http;
    }

    $onInit() {
        this.uploading = false;
        this.otvoren = OTVOREN;
        this.uobradi = UOBRADI;
        this.zakljucan = ZAKLJUCAN;
        this.storniran = STORNIRAN;
        this.progress = 0;
        this.refreshState();
        // this.uploader.onBeforeUploadItem = (item) => {
        //      item.formData.push({radni_nalog: this.item.id});
        // };
        // this.uploader.bind('beforeupload', (event, item) => {
        //     item.formData.push({radni_nalog: this.item.id});
        // });
    }

    uploadDocument(file) {
        const $cookies = this.$cookies();
        const uploader = this.upload();
        if (file) {
            this.uploading = true;
            uploader
                .upload({
                    url: '/api/radni_nalozi/dokumentNaloga',
                    headers: {
                        'X-CSRFToken': $cookies.get('csrftoken')
                    },
                    data: {
                        dokument: file,
                        radni_nalog: this.item.id
                    }
                })
                .then(
                    response => {
                        this.uploading = false;
                        this.refreshState();
                    },
                    error => {
                        this.uploading = false;
                        this.logger.error('Oupss...', error.data);
                    },
                    evt => {
                        this.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }
                );
        }
    }

    deleteImage(item) {
        const DS = this.datastore();
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: 'Brisanje slike',
                text: `Za potvrdu brisanja upišite 'da'`,
                type: 'input',
                showCancelButton: true,
                closeOnConfirm: false
            },
            inputValue => {
                window.onkeydown = previousWindowKeyDown;
                if (inputValue === false) return false;
                if (inputValue === 'da') {
                    DS.destroy('DokumentNaloga', item.id).then(
                        data => {
                            this.refreshState();
                            swal('Slika obrisana', '', 'success');
                            this.refreshState();
                        },
                        error => {
                            this.logger.error('Oops...', error.data);
                        }
                    );
                    return true;
                }
                swal.showInputError('Nedozvoljena vrijednost');
                return false;
            }
        );
    }

    refreshState() {
        const DS = this.datastore();
        DS.find('RadniNalog', this.id, { bypassCache: true })
            .then(radniNalog => {
                this.item = radniNalog;
                this.pageTitle = `Radni nalog: ${this.item.sifra_naloga}`;
                this.pageDesc = `<i class="fa fa-check-square-o"></i> Status: ${this.item.status}`;
            })
            .then(() => {
                this.resolveReferences()
                    .then(() => {
                        return this.getFaze();
                    })
                    .then(response => {
                        this.faze = response;
                        return this.getStavke();
                    })
                    .then(response => {
                        this.stavke = response;
                        this.groupStavke();
                        return this.getDokumente();
                    })
                    .then(dokumenti => {
                        this.dokumenti = [];
                        for (var i = 0, j = dokumenti.length; i < j; i = i + 3) {
                            this.dokumenti.push(dokumenti.splice(0, 3));
                        }
                    });
            });
    }

    getFaze() {
        const DS = this.datastore();
        return DS.findAll('FazaNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
    }

    getStavke() {
        const DS = this.datastore();
        return DS.findAll('StavkaNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
    }

    getDokumente() {
        const DS = this.datastore();
        return DS.findAll('DokumentNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
    }

    groupStavke() {
        // grupiraj stavke naloga po protetskom radu
        // {
        //     "protetski_rad": 21,
        //     "pozicije": [
        //            12,
        //            22,
        //            18
        //     ],
        //     cjenik: 1
        // },

        const DS = this.datastore();
        const StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
        this.groupedStavke = StavkaNaloga.group(this.stavke);
    }

    doPozicije() {
        const modal = this.$uibModal.open({
            component: 'odabirPozicijaForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return {};
                }
            }
        });

        modal.result.then(pozicije => {
            this.$timeout(() => {
                this.insertStavku(pozicije);
            }, 500);
        });
    }

    insertStavku(pozicije) {
        const DS = this.datastore();
        const model = {
            radni_nalog: this.item.id
        };

        if (pozicije.length === 1) {
            model.pozicija = pozicije[0].broj;
        }
        const stavkaForm = this.$uibModal.open({
            component: 'stavkaNalogaForm',
            size: 'lg-extra',
            resolve: {
                item: function() {
                    return model;
                }
            }
        });

        stavkaForm.result.then(model => {
            let promises = [];

            if (pozicije.length > 0) {
                _.forEach(pozicije, pozicija => {
                    let clone = _.cloneDeep(model);
                    clone.pozicija = pozicija.broj;
                    promises.push(DS.create('StavkaNaloga', clone));
                });
            } else {
                promises.push(DS.create('StavkaNaloga', model));
            }

            this.$q
                .all(promises)
                .then(() => {
                    this.refreshState();
                })
                .catch(error => {
                    this.logger.error('Oops...', error.data);
                });
        });
    }

    editStavku(item) {
        const DS = this.datastore();
        const model = item;
        const modal = this.$uibModal.open({
            component: 'stavkaNalogaForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                }
            }
        });

        modal.result.then(model => {
            DS.update('StavkaNaloga', model.id, model).then(() => {
                this.refreshState();
            });
        });
    }

    resolveReferences() {
        let models = [];
        let datastore = this.datastore();

        _.forOwn(this.fazeListView.getReferences(), (value, key) => {
            models.push(datastore.definitions[value.targetEntity().name()]);
        });

        _.forOwn(this.stavkeListView.getReferences(), (value, key) => {
            models.push(datastore.definitions[value.targetEntity().name()]);
        });

        return this.$q.all(models.map(m => m.findAll()));
    }

    editFazu(item) {
        const DS = this.datastore();
        const model = item;
        const view = this.fazeEditView;
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                },
                formClass: function() {
                    return 'standard';
                }
            }
        });

        modal.result.then(model => {
            DS.update('FazaNaloga', model.id, model)
                .then(() => {
                    this.refreshState();
                })
                .catch(error => {
                    this.logger.error('Oupss...', error.data);
                });
        });
    }

    deleteFazu(item) {
        const DS = this.datastore();
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: 'Brisanje probe',
                text: `Za potvrdu brisanja upišite 'da'`,
                type: 'input',
                showCancelButton: true,
                closeOnConfirm: false
            },
            inputValue => {
                window.onkeydown = previousWindowKeyDown;
                if (inputValue === false) return false;
                if (inputValue === 'da') {
                    DS.destroy('FazaNaloga', item.id).then(
                        data => {
                            this.refreshState();
                            swal('Proba obrisana', '', 'success');
                        },
                        error => {
                            this.logger.error('Oops...', error.data);
                        }
                    );
                    return true;
                }
                swal.showInputError('Nedozvoljena vrijednost');
                return false;
            }
        );
    }

    insertFazu() {
        const DS = this.datastore();
        const model = {
            radni_nalog: this.item.id
        };
        const view = this.fazeEditView;
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                },
                formClass: function() {
                    return 'standard';
                }
            }
        });

        modal.result.then(model => {
            DS.create('FazaNaloga', model)
                .then(() => {
                    this.refreshState();
                })
                .catch(error => {
                    this.logger.error('Oupss...', error.data);
                });
        });
    }

    setStatus(status) {
        const $http = this.$http();
        const previousWindowKeyDown = window.onkeydown;
        $http.put(`/api/radni_nalozi/radniNalozi/${this.item.id}/postavi_status`, { status: status }).then(
            response => {
                swal(
                    {
                        title: 'Zahvaljujemo',
                        text: 'Podaci su uspješno ažurirani',
                        type: 'success',
                        closeOnConfirme: true
                    },
                    () => {
                        window.onkeydown = previousWindowKeyDown;
                        this.refreshState();
                    }
                );
            },
            error => {
                this.logger.error('Oupss...', error.data);
            }
        );
    }
}

RadniNalogDetailsController.$inject = [
    'DS',
    'AppConfiguration',
    '$uibModal',
    '$q',
    '$timeout',
    'Upload',
    '$cookies',
    'logger',
    '$http'
];

const RadniNalogDetailsComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RadniNalogDetailsController,
    controllerAs: 'vm',
    bindings: {
        id: '<'
    }
};

export { RadniNalogDetailsComponent };
export { RadniNalogDetailsController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogDetails.component.js